import { B1BatteryAlmostFull, B1BatteryAutonomy, B1BatteryFull, B1BatteryLow, B1BatteryMidCharge } from '@e3dc-react/icons'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import React from 'react'
import { getBatteryIconLevel } from '../../utils/battery-icon-level'

interface Props {
  hasError?: boolean
  stateOfCharge?: number
  hide?: boolean // battery is always visible unless fetching the relevant data fails.
}

const BatteryStatusIcon: React.FC<Props> = ({ hasError = false, stateOfCharge, hide = false }) => {
  const tooltipText = hasError ? 'installation-status.battery.tooltip-error' : 'installation-status.battery.tooltip-ok'
  const percentageStateOfCharge = stateOfCharge === undefined ? undefined : Math.round(stateOfCharge * 100)

  if (hide) return null

  return (
    <OptionalTooltipWrapper titleKey={tooltipText} titleValue={percentageStateOfCharge ?? 0}>
      <Icon hasError={hasError} stateOfCharge={stateOfCharge} />
    </OptionalTooltipWrapper>
  )
}

export default BatteryStatusIcon

// #region Icon
interface IconProps {
  hasError: boolean
  stateOfCharge?: number
}

const Icon: React.FC<IconProps> = ({ hasError, stateOfCharge = 0 }) => {
  if (hasError) return <B1BatteryAutonomy color={'error'} />

  const level = getBatteryIconLevel(stateOfCharge)
  if (level === 'Full') return <B1BatteryFull />
  if (level === 'AlmostFull') return <B1BatteryAlmostFull />
  if (level === 'MidCharge') return <B1BatteryMidCharge />
  return <B1BatteryLow />
}
// #endregion Icon
